import { OriginRouteTypeEnum } from 'Portal/src/stores/orderStore/orderStore.types'

export const BACK_BUTTON_TRANSLATION_IDS: Record<OriginRouteTypeEnum, string> =
  {
    [OriginRouteTypeEnum.Rental]: 'NewOrderConfirmation_to_rental',
    [OriginRouteTypeEnum.Rentals]: 'NewOrderConfirmation_to_rentals',
    [OriginRouteTypeEnum.Employee]: 'NewOrderConfirmation_to_employee',
  }
